angular.module(NgAppName).component("crCountryDropdown", {
	templateUrl: "crCountryDropdown.html",
	bindings: {
		inputFieldId: "@",
		inputFieldName: "@",
		activePhoneNumber: "@",
		placeholder: "@",
		form: "<",
		errorMessages: "<",
		user: "<",
		customId: '@',
		isRequired: "<",
		showCheckMark: "<",
		showErrorOnSubmitOnly: "<",
		tabindexOrder: "<",
		onFieldChange: "&",
		onPhoneHasError: '&',
		isMobile: '<'
	},
	controller: ["$element", "patterns", 'PubSub', function($element, patterns, PubSub) {
		var ctrl = this;
		ctrl.inputFieldId = 'form-phone-' + Date.now();
		this.patterns = patterns;
		this.isOpened = false;
		this.lastKeyPressed = null;
		this.input = $element.find("input");
		this.isRequired = this.isRequired === false ? false : true;
		this.showCheckMark = this.showCheckMark === false ? false : true;
		this.showErrorOnSubmitOnly = this.showErrorOnSubmitOnly === true ? true : false;
		this.customId = new Date().getTime();

		if (!this.inputFieldName) {
			this.inputFieldName = "phone";
		}

		if (this.activePhoneNumber) {
			// remove the dash in the active phone number
			if (this.activePhoneNumber.indexOf("-") > -1) {
				this.activePhoneNumber = this.activePhoneNumber.replace(/-/g, "");
			}

			if (typeof(this.user) === "undefined") {
				this.user = {};
			}

			this.user.phone = this.activePhoneNumber;
		}

		this.fieldChange = function(type) {
			this.form[this.inputFieldName].interacted = true;

			this.onFieldChange({key: type});
		};

		this.onKeyDown = function(e) {
			this.lastKeyPressed = e.keyCode;
		}; 

		this.inErrorState = function() {
			let flag = false;
			if (typeof this.form !== "undefined") {
				if (this.showErrorOnSubmitOnly) {
					flag = this.form[this.inputFieldName].$invalid && (this.form.$submitted && this.form[this.inputFieldName].$touched && !this.form[this.inputFieldName].interacted);
				} else {
					flag = this.form[this.inputFieldName].$invalid && (this.form[this.inputFieldName].$touched || this.form.$submitted);
				}
				if (ctrl.isMobile) {
					this.onPhoneHasError({flag: flag});
				}
			}
			return flag;
		};
	}]
});
